import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LOADING } from '../../../constants/common-labels.constants';

interface TableLoadingRowProp {
    // todo: refactor this ololo, it is hard to guess why the length of content is affecting UI of loading
    contentLength?: number | null;
    colSpan?: number;
    className?: string;
}

const TableLoadingRow = (props: TableLoadingRowProp) => {
    const colSpan = props.colSpan || 5;

    switch (props.contentLength) {
        case undefined:
            return <tr>
                        <td className={classNames('table-loading', props.className)} colSpan={colSpan}>
                            <FormattedMessage
                                {...LOADING}
                                values={{suffix: '...'}}
                            />
                        </td>
                    </tr>;
        case 0:
            { /* todo: loading shall be responsible for loading. 'No Content' is not a subject for this component. Neight 'null'*/ }
            return <tr>
                        <td className='table-loading' colSpan={colSpan}>
                            <FormattedMessage
                                description='Placeholder text'
                                defaultMessage='No content'
                                id='oe.content.noContent'
                            />
                        </td>
                    </tr>;
        default:
            return (null);
    }
};

export default TableLoadingRow;
